import React, { useState, useMemo } from 'react'
import { selectBrand, setBrand } from '../filterSlice'
import _ from 'lodash'
import parts from '../../../utils/constants/parts'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrency } from '../../currency/currencySlice'
import setPartsPrice from '../../../utils/parts/setPartsPrice'
import { Checkbox as CheckboxAntd, Radio } from 'antd'

const Brand = ({ refFilterbody, setResultHeight }) => {
    const dispatch = useDispatch()
    const currency = useSelector(selectCurrency)
    const currencylogo = currency.toLowerCase() === 'rub' ?  '₽' : '€';
    const filterSelectedBrand = useSelector(selectBrand)

    const partsWithCurrency = useMemo(() => setPartsPrice(parts, currency), [currency])

    const sortNameField = 'name'
    const sortPriceField = 'price'
    const limitDefault = 5
    const limitIncrement = 10

    const [sort, setSort] = useState(sortPriceField)
    const [limit, setLimit] = useState(limitDefault)

    const brandsCnt = _.chain(partsWithCurrency)
        .groupBy((part) => part.brand_title)
        .size()
        .value()

    const getBrands = () => {
        const sortIteratees = [sort]

        if (sort === sortPriceField) {
            // Brands with zero price always in the end
            sortIteratees.unshift((brand) => brand[sortPriceField] <= 0)
        }

        return _.chain(partsWithCurrency)
            .groupBy((part) => part.brand_title)
            .map((parts) => {
                const zeroPrice = 0
                const first = _.first(parts)

                // Some parts can have 0 prices, we don't need them in min price calculation
                const prices = parts
                    .map((part) => Math.floor(part.price_src))
                    .filter((price) => price > 0)
                const minPrice = prices.length ? Math.min(...prices) : zeroPrice

                return {
                    name: first.brand_title,
                    price: minPrice
                }
            })
            .sortBy(sortIteratees)
            .slice(0, limit)
            .value()
    }

    const brands = getBrands()

    const sortByName = (e) => setSort(sortNameField)
    const sortByPrice = (e) => setSort(sortPriceField)
    const showMore = (e) => {
        setLimit(limit + limitIncrement)
        const heightFilter =
            refFilterbody.current.getBoundingClientRect().height + 30 * limitIncrement
        if (window.innerWidth > 768 && heightFilter > 1000) setResultHeight(heightFilter)
        else if (window.innerWidth > 768 && heightFilter < 1000) setResultHeight(1000)
    }

    const onChange = (checkedValues) => {
        dispatch(setBrand(checkedValues))
    }

    return (
        <div className="search-filter__prop">
            <div className="search-filter__prop-header">
                <div>Бренды</div>
                <Radio.Group className="sort-brand" defaultValue={sort} buttonStyle="solid">
                    <Radio.Button value={sortPriceField} onClick={sortByPrice}>
                        {currencylogo}
                    </Radio.Button>
                    <Radio.Button value={sortNameField} onClick={sortByName}>
                        Ая
                    </Radio.Button>
                </Radio.Group>
            </div>
            <CheckboxAntd.Group
                className="checkbox__wrapper"
                onChange={onChange}
                value={filterSelectedBrand}
            >
                {brands.map((item) => (
                    <CheckboxAntd className="checkbox" key={item.name} value={item.name}>
                        <span className="checkbox__price">{item.name}</span>{' '}
                        <span className="checkbox__price">
                            {item.price <= 0 ? (
                                'Узнать'
                            ) : (
                                <>
                                <span style={{ fontSize: '0.8em', verticalAlign: 'bottom', color: '#888' }}>от</span>&nbsp;
                                {item.price}&nbsp;{currencylogo}
                                </>
                            )}
                            </span>

                    </CheckboxAntd>
                ))}
                {limit < brandsCnt && (
                    <button className="checkbox__show-more" onClick={showMore}>
                        Показать еще
                        <svg
                            width="12"
                            height="8"
                            viewBox="0 0 12 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M6 0L0 6L1.41 7.41L6 2.83L10.59 7.41L12 6L6 0Z" fill="black" />
                        </svg>
                    </button>
                )}
            </CheckboxAntd.Group>
        </div>
    )
}

export default Brand
